




































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import LineChart from '@/components/Shared/LineChart.vue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatCurrency, formatPercent, formatNumber, formatDays, formatChangePercent } from '@/lib/reportFormatters';

@Component({ name: 'PermReports', components: { LineChart } })
export default class PermReports extends GiganautVue {

  pipelineHeaders = [
    { text: 'Stage', value: 'stage' },
    { text: 'Count', value: 'count', align: 'end' },
    { text: 'Value', value: 'value', align: 'end' },
  ];

  funnelHeaders = [
    { text: 'From', value: 'fromStage' },
    { text: 'To', value: 'toStage' },
    { text: 'From Count', value: 'fromCount', align: 'end' },
    { text: 'To Count', value: 'toCount', align: 'end' },
    { text: 'Conversion Rate', value: 'conversionRate', align: 'end' },
  ];

  placementPositionHeaders = [
    { text: 'Position', value: 'label' },
    { text: 'Revenue', value: 'revenue', align: 'end' },
    { text: 'GP', value: 'gp', align: 'end' },
    { text: 'Margin', value: 'margin', align: 'end' },
    { text: 'Shifts', value: 'shifts', align: 'end' },
  ];

  get pipelineSnapshot() { return ManagementReportsModule.pipelineSnapshot; }
  get conversionFunnel() { return ManagementReportsModule.conversionFunnel; }
  get placements() { return ManagementReportsModule.placements; }

  get placementTrendChart() {
    const trend = this.placements ? this.placements.trend : [];
    return {
      labels: trend.map(t => t.period),
      datasets: [
        {
          label: 'Placements',
          borderColor: '#3f51b5',
          backgroundColor: 'rgba(63,81,181,0.1)',
          data: trend.map(t => t.placements),
          fill: true,
        },
        {
          label: 'Fees',
          borderColor: '#ff5c00',
          backgroundColor: 'rgba(255,92,0,0.1)',
          data: trend.map(t => t.fees),
          fill: true,
          yAxisID: 'y2',
        },
      ],
    };
  }

  get placementChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          { id: 'y1', position: 'left', ticks: { beginAtZero: true } },
          { id: 'y2', position: 'right', gridLines: { drawOnChartArea: false },
            ticks: { callback: (v: any) => formatCurrency(v) } },
        ],
      },
    };
  }

  fmtCurrency(v: number) { return formatCurrency(v); }
  fmtPct(v: number) { return formatPercent(v); }
  fmtNum(v: number) { return formatNumber(v); }
  fmtDays(v: number) { return formatDays(v); }
}
